import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded";

export default function CollapseIcon() {
  return <ArrowDropDownRoundedIcon />;
}
